<template>
	<div>
		<loading v-if="!loaded" />
		<el-tabs v-model="tabName" v-if="loaded">
			<el-tab-pane label="អតិថិជនទាំងអស់" name="first"></el-tab-pane>
			<el-tab-pane label="បង្កើតអតិថិជនថ្មី" name="second"></el-tab-pane>
			<el-tab-pane label="អតិថិជនមិនមានកញ្ចប់ថ្មីចាប់ពី ៣ ថ្ងៃ" name="third" v-if="allow_user('sa')"></el-tab-pane>
		</el-tabs>
		<div v-if="tabName == 'first' && loaded">
			<div class="md-layout">
				<div class="md-layout-item md-small-size-100 md-size-40">
					<md-field>
						<label>ស្វែងរកតាមរយៈ ឈ្មោះ លេខទូរស័ព្ទ ឬ លេខកូដ</label>
						<md-input v-model="search.text" type="text" @keyup.enter="searchHandler()"></md-input>
					</md-field>
				</div>
				<div class="md-layout-item md-size-30">
					<md-button class="md-raised md-primary" @click="searchHandler()" style="width: 100%">ស្វែងរក
					</md-button>
				</div>
			</div>

			<md-table v-if="clientList.length > 0">
				<md-table-row>
					<md-table-head>ល.រ.</md-table-head>
					<md-table-head>លេខកូដ និងថ្ងៃបង្កើត</md-table-head>
					<md-table-head>ឈ្មោះ និងលេខទូរស័ព្ទ</md-table-head>
					<md-table-head>គណនីធនាគារ</md-table-head>
					<md-table-head>តេឡេក្រាម</md-table-head>
					<!-- <md-table-head>តេឡេក្រាម</md-table-head> -->
					<!-- <md-table-head>កំណត់ចំណាំ</md-table-head> -->
					<md-table-head>អ្នកទីផ្សារ</md-table-head>
					<md-table-head>ទីតាំង</md-table-head>
					<md-table-head>បញ្ចុះតម្លៃ</md-table-head>
					<md-table-head>បានកំណត់ទីតាំងក្នុង App</md-table-head>
					<!-- <md-table-head>ថ្ងៃបង្កើត</md-table-head> -->
					<md-table-head>សកម្មភាព</md-table-head>
				</md-table-row>

				<md-table-row v-for="(client, index) in clientList">
					<md-table-cell>{{ index + 1 }}</md-table-cell>
					<md-table-cell>
						<!-- <img src="@/assets/img/default-member.png" style="width: 34px; margin-right:5px"> -->
						<b>{{ client.hash_id }}</b><br>{{ config.datelify(client.created_date) }}
					</md-table-cell>
					<md-table-cell>{{ client.name }}<br>{{ client.phone }}</md-table-cell>
					<md-table-cell>
						<div class="bank-row">
							<img :src="config.getProfileUrl(client.bank_usd)" class="bank-image" />
							<img :src="config.getProfileUrl(client.bank_khr)" class="bank-image" />
						</div>
					</md-table-cell>
					<md-table-cell>
						<img :src="config.getProfileUrl(client.telegram_qr)" class="bank-image" />
					</md-table-cell>
					
					<!-- <md-table-cell>{{ client.note }}</md-table-cell> -->
					<md-table-cell>
						<span v-if="client.referral_name != null">{{ client.referral_name }}</span>
						<span v-else>មិនមាន</span>
					</md-table-cell>
					<md-table-cell>
						<span v-if="client.location_name" class="green">{{ client.location_name }}</span>
						<span v-else class="late">មិនមានទីតាំង</span>
					</md-table-cell>
					<md-table-cell>
						<span v-if="client.discount_usd > 0" class="green">{{config.moneylify(client.discount_usd)}} និង {{config.moneylify(client.discount_khr, "khr")}}</span>
						<span v-else class="late">មិនមាន</span>
						
					</md-table-cell>
					<md-table-cell>
						<span v-if="client.location_lat" class="green">បានដំឡើង</span>
						<span v-else class="late">មិនទាន់</span>
					</md-table-cell>
					<!-- <md-table-cell>{{ config.datelify(client.created_date) }}</md-table-cell> -->
					<md-table-cell>
						<router-link :to="'/clients/detail/' + client.hash_id">
							<md-button class="md-just-icon md-simple md-success">
								<md-icon>visibility</md-icon>
								<md-tooltip md-direction="top">បង្ហាញបន្ថែម</md-tooltip>
							</md-button>
						</router-link>
						<router-link :to="'/clients/edit/' + client.hash_id">
							<md-button class="md-just-icon md-simple md-info">
								<md-icon>edit</md-icon>
								<md-tooltip md-direction="top">កែប្រព័ត៌មាន</md-tooltip>
							</md-button>
						</router-link>
						<md-button class="md-just-icon md-simple md-primary" @click="discount(client.hash_id, 1000, 0.25)" v-if="allow_user('sa') && client.discount_usd == 0">
							<md-icon>percent</md-icon>
							<md-tooltip md-direction="top">បញ្ចុះតម្លៃ</md-tooltip>
						</md-button>
						<md-button class="md-just-icon md-simple md-danger" @click="discount(client.hash_id, 0, 0)" v-if="allow_user('sa') && client.discount_usd > 0">
							<md-icon>money_off</md-icon>
							<md-tooltip md-direction="top">ឈប់បញ្ចុះតម្លៃ</md-tooltip>
						</md-button>
						<md-button class="md-just-icon md-simple md-danger" @click="delete_client(client.hash_id)" v-if="allow_user('sa')">
							<md-icon>delete</md-icon>
							<md-tooltip md-direction="top">លុបអតិថិជន</md-tooltip>
						</md-button>
					</md-table-cell>
				</md-table-row>
			</md-table>

			<h4 class="text-center" v-if="clientList.length == 0 && loadMore == true">មិនមានអតិថិជន</h4>
			<div class="places-buttons text-center" v-if="loadMore">
				<md-button class="md-primary" @click="searchHandler(true)"
					v-if="allow_user('sa|ad')">បង្ហាញបន្ថែម</md-button>
			</div>
		</div>

		<div v-if="tabName == 'second'">
			<div class="md-layout">
				<div class="md-layout-item md-small-size-100 md-size-50">
					<div class="md-layout-item md-small-size-100 md-size-100">
						<h3>ព័ត៌មានអតិថិជន</h3>
					</div>
					<div class="md-layout-item md-small-size-100 md-size-100 text-right">
						<span class="late">* តម្រូវឱ្យបំពេញ</span>
					</div>
					<div class="md-layout">
						<div class="md-layout-item md-small-size-100 md-size-50">
							<md-field>
								<label>ឈ្មោះអតិថិជន *</label>
								<md-input type="text" v-model="client.name"></md-input>
							</md-field>
						</div>
						<div class="md-layout-item md-small-size-100 md-size-50">
							<md-field>
								<label>លេខទូរស័ព្ទអតិថិជន *</label>
								<md-input type="text" v-model="client.phone"></md-input>
							</md-field>
						</div>
						<div class="md-layout-item md-small-size-100 md-size-50">
							<label>ទីតាំង *</label>
							<v-select label="full_name" inputId="id" :clearable="false" :options="locationList"
								v-model="client.locationArray">
							</v-select>
						</div>
						<div class="md-layout-item md-small-size-100 md-size-50">
							<label>អ្នកទីផ្សារ *</label>
							<v-select label="name" inputId="id" :clearable="false" :options="referralList"
								v-model="client.referralArray">
							</v-select>
						</div>
						<!-- <div class="md-layout-item md-small-size-100 md-size-50">
							<md-field>
								<label>តេឡេក្រាម Link</label>
								<md-input type="text" v-model="client.telegram_link">
								</md-input>
							</md-field>
						</div> -->
						<div class="md-layout-item md-small-size-100 md-size-100">
							<md-field>
								<label>ទំតាំង Link</label>
								<md-input type="text" v-model="client.location_link">
								</md-input>
							</md-field>
						</div>
						<div class="md-layout-item md-small-size-100 md-size-100">
							<md-field>
								<label>កំណត់សំគាល់</label>
								<md-input type="text" v-model="client.description">
								</md-input>
							</md-field>
						</div>

						<div class="md-layout-item md-small-size-100 md-size-50 text-center">
							<div style="width:100%">
								<p>គណនី USD *</p>
								<input type="file" ref="image_usd" accept="image/*" style="display: none;"
									@change="processFileUSD($event)">
								<img class="thumb-profile" :src="config.getProfileUrl()"
									v-if="client.bank_usd.length == 0">
								<img class="thumb-profile" :src="config.getProfileUrl(client.bank_usd)"
									v-if="client.bank_usd.length > 0">
							</div>
							<md-button class="md-primary" @click="openUSD()"
								v-if="client.bank_usd.length == 0">បញ្ចូលរូបភាព</md-button>
							<md-button class="md-danger" @click="removeUSD()" v-else>លុបចោល</md-button>
						</div>
						<div class="md-layout-item md-small-size-100 md-size-50 text-center">
							<div style="width:100%">
								<p>គណនី KHR *</p>
								<input type="file" ref="image_khr" accept="image/*" style="display: none;"
									@change="processFileKHR($event)">
								<img class="thumb-profile" :src="config.getProfileUrl()"
									v-if="client.bank_khr.length == 0">
								<img class="thumb-profile" :src="config.getProfileUrl(client.bank_khr)"
									v-if="client.bank_khr.length > 0">
							</div>
							<md-button class="md-primary" @click="openKHR()"
								v-if="client.bank_khr.length == 0">បញ្ចូលរូបភាព</md-button>
							<md-button class="md-danger" @click="removeKHR()" v-else>លុបចោល</md-button>
						</div>
						<div class="md-layout-item md-small-size-100 md-size-50 text-center">
							<div style="width:100%">
								<p>គណនី Telegram</p>
								<input type="file" ref="image_telegram" accept="image/*" style="display: none;"
									@change="processFileTelegram($event)">
								<img class="thumb-profile" :src="config.getProfileUrl()"
									v-if="client.telegram_qr.length == 0">
								<img class="thumb-profile" :src="config.getProfileUrl(client.telegram_qr)"
									v-if="client.telegram_qr.length > 0">
							</div>
							<md-button class="md-primary" @click="openTelegram()"
								v-if="client.telegram_qr.length == 0">បញ្ចូលរូបភាព</md-button>
							<md-button class="md-danger" @click="removeTelegram()" v-else>លុបចោល</md-button>
						</div>
					</div>
				</div>
				<div class="md-layout-item md-small-size-100 md-size-50">
					<div class="md-layout-item md-small-size-100 md-size-100">
						<h3>ព័ត៌មានសង្ខេប</h3>
					</div>
					<div class="md-layout-item md-small-size-100 md-size-100">
						<md-table>
							<md-table-row>
								<md-table-cell style="width: 50%;">ឈ្មោះអតិថិជន</md-table-cell>
								<md-table-cell style="width: 5px">៖</md-table-cell>
								<md-table-cell>
									<span v-if="String(client.name).length > 0">{{client.name}}</span>
									<span v-else>មិនទាន់មាន</span>
								</md-table-cell>
							</md-table-row>
							<md-table-row>
								<md-table-cell>លេខទូរស័ព្ទអតិថិជន</md-table-cell>
								<md-table-cell>៖</md-table-cell>
								<md-table-cell>
									<span v-if="String(client.phone).length > 0">{{client.phone}}</span>
									<span v-else>មិនទាន់មាន</span>
								</md-table-cell>
							</md-table-row>
							<md-table-row>
								<md-table-cell>ទីតាំង</md-table-cell>
								<md-table-cell>៖</md-table-cell>
								<md-table-cell>
									<span
										v-if="String(client.location_id).length > 0">{{client.locationArray.name}}</span>
									<span v-else>មិនទាន់មាន</span>
								</md-table-cell>
							</md-table-row>
							<md-table-row>
								<md-table-cell>អ្នកទីផ្សារ</md-table-cell>
								<md-table-cell>៖</md-table-cell>
								<md-table-cell>
									<span
										v-if="String(client.referral_id).length > 0">{{client.referralArray.name}}</span>
									<span v-else>មិនទាន់មាន</span>
								</md-table-cell>
							</md-table-row>
							<!-- <md-table-row>
								<md-table-cell>តេឡេក្រាម Link</md-table-cell>
								<md-table-cell>៖</md-table-cell>
								<md-table-cell>
									<span v-if="String(client.telegram_link).length > 0">{{client.telegram_link}}</span>
									<span v-else>មិនទាន់មាន</span>
								</md-table-cell>
							</md-table-row> -->
							<md-table-row>
								<md-table-cell>ទីតាំង Link</md-table-cell>
								<md-table-cell>៖</md-table-cell>
								<md-table-cell>
									<span v-if="String(client.location_link).length > 0">{{client.location_link}}</span>
									<span v-else>មិនទាន់មាន</span>
								</md-table-cell>
							</md-table-row>
							<md-table-row>
								<md-table-cell>កំណត់សំគាល់</md-table-cell>
								<md-table-cell>៖</md-table-cell>
								<md-table-cell>
									<span v-if="String(client.description).length > 0">{{client.description}}</span>
									<span v-else>មិនទាន់មាន</span>
								</md-table-cell>
							</md-table-row>
						</md-table>
					</div>
				</div>
				<div class="md-layout-item md-size-100 text-right">
					<md-button class="md-raised md-primary" @click="postClient()">បង្កើត</md-button>
				</div>
			</div>
		</div>

		<div v-if="tabName == 'third' && loaded">
			<md-table v-if="activeClientList.length > 0">
				<md-table-row>
					<md-table-head>ល.រ.</md-table-head>
					<md-table-head>លេខកូដ និងថ្ងៃបង្កើត</md-table-head>
					<md-table-head>ឈ្មោះ និងលេខទូរស័ព្ទ</md-table-head>
					<md-table-head>ថ្ងៃដាក់កញ្ចប់ឥវ៉ាន់ចុងក្រោយ</md-table-head>
					<md-table-head>សកម្មភាព</md-table-head>
				</md-table-row>

				<md-table-row v-for="(client, index) in activeClientList">
					<md-table-cell>{{ index + 1 }}</md-table-cell>
					<md-table-cell><b>{{ client.hash_id }}</b><br>{{ config.datelify(client.created_date) }}</md-table-cell>
					<md-table-cell>{{ client.name }}<br>{{ client.phone }}</md-table-cell>
					
					<md-table-cell>{{ config.datelify(client.last_package_date) }}<br>{{config.timelify(client.last_package_date)}}</md-table-cell>
					<md-table-cell>
						<router-link :to="'/clients/detail/' + client.hash_id">
							<md-button class="md-just-icon md-simple md-success">
								<md-icon>visibility</md-icon>
								<md-tooltip md-direction="top">បង្ហាញបន្ថែម</md-tooltip>
							</md-button>
						</router-link>
						<md-button class="md-just-icon md-simple md-danger" @click="hide_active_client(client.hash_id)" v-if="allow_user('sa')">
							<md-icon>visibility_off</md-icon>
							<md-tooltip md-direction="top">ឈប់បង្ហាញ</md-tooltip>
						</md-button>
					</md-table-cell>
				</md-table-row>
			</md-table>
		</div>

		<md-dialog-confirm :md-active.sync="delete_alert" md-title="តើអ្នកពិតជាចង់លុបអតិថិជននេះមែនទេ ?"
			md-content="អតិថិជននឹងត្រូវបានលុប" md-confirm-text="លុប" md-cancel-text="បោះបង់"
			@md-cancel="cancel_delete" @md-confirm="delete_client" />
	</div>

</template>

<script>
	import { Datetime } from 'vue-datetime';
	export default {
		components: { Datetime },
		created() {
			this.searchHandler();
		},
		data() {
			return {
				tabName: "first",
				loaded: false,
				delete_alert: false,
				delete_selected: '',
				search: {
					text: ""
				},
				search_active: {
					text: ""
				},
				client: {
					name: "",
					phone: "",
					description: "",
					bank_usd: "",
					bank_khr: "",
					telegram_qr: "",
					telegram_link: "មិនមាន",
					location_link: "",
					referral_id: "",
					referralArray: "",
					location_id: "",
					locationArray: ""
				},
				loadMore: true,
				clientList: [],
				activeClientList: [],
				referralList: [],
				locationList: []

			}
		},
		watch: {
			'tabName': function(val) {
				if(val == "first") {
					this.searchHandler();
				}
				if(val == "second") {
					this.getReferral();
					this.getLocation();
				}
				if(val == "third") {
					this.searchActiveClientHandler();
				}
			},
			'client.referralArray': function (val) {
				if (String(this.client.referralArray).length > 5) {
					this.client.referral_id = this.client.referralArray.id;
				} else {
					this.client.referral_id = "";
				}
			},
			'client.locationArray': function (val) {
				if (String(this.client.locationArray).length > 5) {
					this.client.location_id = this.client.locationArray.id;
				} else {
					this.client.location_id = "";
				}
			}
		},
		methods: {
			postClient() {
				if (!this.checkValidation()) return false;
				this.$http.post(this.config.api + "/admin/client/post", {
					client: this.client
				}).then(data => {
					if (data.body.status == 'success') {
						this.tabName = 'first'
						this.$notification.notify({
							message: "អ្នកផ្ញើឥវ៉ាន់ត្រូវបានបង្កើតដោយជោគជ័យ។",
							icon: 'done',
							type: 'success'
						});
						this.search.text = "";
						this.searchHandler();
						this.clearAll();
					}
				})
			},
			getReferral() {
				this.$http.post(this.config.api + "/admin/referral/search", { text: "", offset: 0 }).then(data => {
					this.referralList = data.body.data;
				})
			},
			getLocation() {
				this.$http.get(this.config.api + "/admin/zone/get/location_list").then(data => {
					this.locationList = data.body.data
				})
			},
			searchHandler(more = false) {
				this.$http.post(this.config.api + "/admin/client/search", {
					text: this.search.text,
					offset: more ? this.clientList.length : 0
				}).then(data => {
					this.loaded = true;
					if (data.body.data.length == 100) this.loadMore = true;
					else this.loadMore = false;
					this.clientList = more ? this.clientList.concat(data.body.data) : data.body.data;
				})
			},
			searchActiveClientHandler(more = false) {
				this.$http.post(this.config.api + "/admin/client/search_active_client", {
					text: this.search.text,
					offset: more ? this.activeClientList.length : 0
				}).then(data => {

					this.activeClientList = more ? this.activeClientList.concat(data.body.data) : data.body.data;
				})
			},
			checkValidation() {
				if (String(this.client.name).length > 0 && String(this.client.phone).length > 0 && String(this.client.bank_usd).length > 0 && String(this.client.bank_khr).length > 0 && String(this.client.telegram_qr).length > 0 && String(this.client.location_id).length > 0) {
					return true;
				} else {
					this.$notification.notify({
						message: "សូមបញ្ចូលព័ត៌មាន។",
						icon: 'info',
						type: 'warning'
					});
					return false;
				}
			},

			processFileUSD(e, image) {
				let files = e.target.files || e.dataTransfer.files;
				if (!files.length) return;

				let formData = new FormData();

				formData.append("image", files[0], 'imagepro');
				this.$http.post(this.config.api + '/admin/client/upload', formData).then(res => {
					if (res.body.status == 'success') {
						this.client.bank_usd = res.body.data.file_hash.replace(".jpg", "");
					}
				})
			},
			processFileKHR(e, image) {
				let files = e.target.files || e.dataTransfer.files;
				if (!files.length) return;

				let formData = new FormData();

				formData.append("image", files[0], 'imagepro');
				this.$http.post(this.config.api + '/admin/client/upload', formData).then(res => {
					if (res.body.status == 'success') {
						this.client.bank_khr = res.body.data.file_hash.replace(".jpg", "");
					}
				})
			},
			processFileTelegram(e, image) {
				let files = e.target.files || e.dataTransfer.files;
				if (!files.length) return;

				let formData = new FormData();

				formData.append("image", files[0], 'imagepro');
				this.$http.post(this.config.api + '/admin/client/upload', formData).then(res => {
					if (res.body.status == 'success') {
						this.client.telegram_qr = res.body.data.file_hash.replace(".jpg", "");
					}
				})
			},
			discount(hash_id, khr, usd) {
				this.$http.post(this.config.api + "/admin/client/discount", {
					client_hash_id: hash_id,
					discount_khr: parseFloat(khr),
					discount_usd: parseFloat(usd)
				}).then(data => {
					this.searchHandler();
				})
			},
			delete_client(hash_id) {
				if(this.delete_selected == "" && this.delete_alert == false) {
					this.delete_alert = true;
					this.delete_selected = hash_id;
					return false;
				}
				this.$http.post(this.config.api + "/admin/client/delete", {
					hash_id: this.delete_selected
				}).then(data => {
					this.searchHandler();
					this.$notification.notify({
						message: "អតិថិជននេះត្រូវបានលុបដោយជោគជ័យ។",
						icon: 'done',
						type: 'success'
					});
				})
			},
			cancel_delete() {
				this.delete_alert = false;
				this.delete_selected = "";
			},
			hide_active_client(hash_id) {
				this.$http.post(this.config.api + "/admin/client/set_last_package", {
					hash_id: hash_id
				}).then(data => {
					this.searchActiveClientHandler();
					this.$notification.notify({
						message: "ជោគជ័យ។",
						icon: 'done',
						type: 'success'
					});
				})
			},
			openUSD() {
				this.$refs['image_usd'].click();
			},
			openKHR() {
				this.$refs['image_khr'].click();
			},
			openTelegram() {
				this.$refs['image_telegram'].click();
			},
			removeUSD(id) {
				this.client.bank_usd = "";
			},
			removeKHR(id) {
				this.client.bank_khr = "";
			},
			removeTelegram(id) {
				this.client.telegram_qr = "";
			},
			clearAll() {
				this.search.text = "";
				this.client = {
					name: "",
					phone: "",
					description: "",
					bank_usd: "",
					bank_khr: "",
					telegram_qr: ""
				}
			}
		}
	}
</script>
<style scoped>
	.product-thumbnail {
		width: 64px;
		height: 64px;
	}

	.thumb-profile {
		width: 70% !important;
	}

	.grid-8 {
		text-align: center;
		max-width: 20%;
		min-width: 20%;
		flex: 0 0 20%;
	}

	.thumb-product {
		width: 50%;
	}

	.bank-row {
		display: flex;
		justify-content: center;
	}

	.bank-image {
		width: 50px !important;
		margin-left: 3px;
	}
</style>


// WEBPACK FOOTER //
// src/pages/Clients/View.vue